/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { FairAction } from './FairActions';
import { createReducer } from '@reduxjs/toolkit';
import { Fair } from 'Api/generated';
export interface IFairsState {
  FairsRequested: boolean;
  Fairs: {
    [key: string]: Fair;
  };
  fairTags: Fair['Tag'][];
  requestedToDelete: Fair[];
  deleted: Fair[];
}

const initialState: IFairsState = {
  FairsRequested: false,
  Fairs: {},
  fairTags: [],
  requestedToDelete: [],
  deleted: [],
};

const FairReducer = createReducer<IFairsState>(initialState, (builder) => {
  builder.addCase(FairAction.Delete, (state: IFairsState, action) => {
    const requestedToDelete = [...state.requestedToDelete, action.payload];
    return {
      ...state,
      requestedToDelete,
    };
  });

  builder.addCase(FairAction.Deleted, (state: IFairsState, action) => {
    console.log(action.payload);
    const deleted = [...state.deleted, action.payload];
    const Fairs = { ...state.Fairs };
    if (action.payload.Id && action.payload.Tag != undefined && action.payload.Tag != null) {
      delete Fairs[action.payload.Tag + action.payload.Id];
    }
    const Tags = new Set(state.fairTags);
    Tags.delete(action.payload.Tag);

    return {
      ...state,
      fairTags: [...Array.from(Tags)],
      Fairs: { ...Fairs },
      deleted,
      requestedToDelete: [...state.requestedToDelete.filter((el) => el !== action.payload)],
    };
  });

  builder.addCase(FairAction.Query, (state) => {
    return {
      ...state,
      FairsRequested: true,
    };
  });
  const arrayToObject = (arr: any[], key1: string, key2: string) => {
    return Object.assign({}, ...arr.map((item) => ({ [item[key1] + item[key2]]: item })));
  };
  builder.addCase(FairAction.Queried, (state: IFairsState, action) => {
    const fairTags = action.payload.map((fair) => fair.Tag);
    return {
      ...state,
      FairsRequested: false,
      Fairs: arrayToObject(action.payload, 'Tag', 'Id'),
      fairTags,
    };
  });

  builder.addCase(FairAction.Updated, (state, action) => {
    const Fairs = { ...state.Fairs };
    if (action.payload.Id && action.payload.Tag) {
      Fairs[action.payload.Tag + action.payload.Id] = action.payload;
    }
    return {
      ...state,
      Fairs,
    };
  });
});

export default FairReducer;
